import transformToCamelCase from '../../shared/transformers/toCamelCaseTransformer';
import conversionRate from '@/utils/conversionRate';

function addId(keywords) {
  let i = 1;
  return keywords.map(keyword => ({
    id: i++,
    ...keyword,
  }));
}

export default function transformSearchTermKeywords(keywords) {
  const camelCaseKeywords = keywords.map(transformToCamelCase);
  const keywordsWithId = addId(camelCaseKeywords);
  return keywordsWithId.map(keyword => ({
    ...keyword,
    avgInstallCost: parseInt(keyword.avgInstallCost),
    conversionRate: conversionRate(
      keyword.installCount,
      keyword.impressionCount,
    ),
  }));
}
